<template>
  <div class="implement_assessment_add assessment">
    <div class="add">
      <div class="title" style="margin-bottom: 20px">
        {{gradeName}}-{{nameName}}
      </div>
      <div>
        <CircleName name="学科学习"></CircleName>
        <table>
          <tbody>
            <tr>
              <th>考核</th>
              <th>家长</th>
              <th>学生</th>
              <th>成长导师</th>
              <th>咨询师</th>
              <th>综合分数</th>
            </tr>
            <tr>
              <td>任务完成</td>
              <td>
                <el-input type="number" v-model="assess.slParentTc"></el-input>
              </td>
              <td>
                <el-input type="number" v-model="assess.slStudentTc"></el-input>
              </td>
              <td>
                <el-input type="number" v-model="assess.slTeacherTc"></el-input>
              </td>
              <td>
                {{assess.lhConsultantTc}}
              </td>
              <td>
                {{Math.round(assess.slParentTc / 100 * 30 + assess.slStudentTc / 100 * 30 + assess.slTeacherTc / 100 * 20 + assess.slConsultantTc / 100 * 20)}}
              </td>
            </tr>
            <tr>
              <td>完成效果</td>
              <td>
                <el-input type="number" v-model="assess.slParentCr"></el-input>
              </td>
              <td>
                <el-input type="number" v-model="assess.slStudentCr"></el-input>
              </td>
              <td>
                <el-input type="number" v-model="assess.slTeacherCr"></el-input>
              </td>
              <td>
                {{assess.slConsultantCr}}
              </td>
              <td>
                {{Math.round(assess.slParentCr / 100 * 30 + assess.slStudentCr / 100 * 30 + assess.slTeacherCr / 100 * 20 + assess.slConsultantCr / 100 * 20)}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <CircleName name="学习习惯"></CircleName>
        <table>
          <tbody>
          <tr>
            <th>考核</th>
            <th>家长</th>
            <th>学生</th>
            <th>成长导师</th>
            <th>咨询师</th>
            <th>综合分数</th>
          </tr>
          <tr>
            <td>任务完成</td>
            <td>
              <el-input type="number" v-model="assess.lhParentTc"></el-input>
            </td>
            <td>
              <el-input type="number" v-model="assess.lhStudentTc"></el-input>
            </td>
            <td>
              <el-input type="number" v-model="assess.lhTeacherTc"></el-input>
            </td>
            <td>
              {{assess.lhConsultantTc}}
            </td>
            <td>
              {{Math.round(assess.slParentCr / 100 * 30 + assess.slStudentCr / 100 * 30 + assess.slTeacherCr / 100 * 20 + assess.slConsultantCr / 100 * 20)}}
            </td>
          </tr>
          <tr>
            <td>完成效果</td>
            <td>
              <el-input type="number" v-model="assess.lhParentCr"></el-input>
            </td>
            <td>
              <el-input type="number" v-model="assess.lhStudentCr"></el-input>
            </td>
            <td>
              <el-input type="number" v-model="assess.lhTeacherCr"></el-input>
            </td>
            <td>
              {{assess.lhConsultantCr}}
            </td>
            <td>
              {{Math.round(assess.lhParentCr / 100 * 30 + assess.lhStudentCr / 100 * 30 + assess.lhTeacherCr / 100 * 20 + assess.lhConsultantCr / 100 * 20)}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div>
        <CircleName name="路径条件"></CircleName>
        <table>
          <tbody>
          <tr>
            <th>考核</th>
            <th>家长</th>
            <th>学生</th>
            <th>成长导师</th>
            <th>咨询师</th>
            <th>综合分数</th>
          </tr>
          <tr>
            <td>任务完成</td>
            <td>
              <el-input type="number" v-model="assess.pcParentTc"></el-input>
            </td>
            <td>
              <el-input type="number" v-model="assess.pcStudentTc"></el-input>
            </td>
            <td>
              <el-input type="number" v-model="assess.pcTeacherTc"></el-input>
            </td>
            <td>
              {{assess.pcConsultantTc}}
            </td>
            <td>
              {{Math.round(assess.pcParentTc / 100 * 30 + assess.pcStudentTc / 100 * 30 + assess.pcTeacherTc / 100 * 20 + assess.pcConsultantTc / 100 * 20)}}
            </td>
          </tr>
          <tr>
            <td>完成效果</td>
            <td>
              <el-input type="number" v-model="assess.pcParentCr"></el-input>
            </td>
            <td>
              <el-input type="number" v-model="assess.pcStudentCr"></el-input>
            </td>
            <td>
              <el-input type="number" v-model="assess.pcTeacherCr"></el-input>
            </td>
            <td>
              {{assess.pcConsultantCr}}
            </td>
            <td>
              {{Math.round(assess.pcParentCr / 100 * 30 + assess.pcStudentCr / 100 * 30 + assess.pcTeacherCr / 100 * 20 + assess.pcConsultantCr / 100 * 20)}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <SummaryTitle title="整体评估"></SummaryTitle>
      <div style="margin-top: 30px">
        <el-input type="textarea"   v-model="assess.overallAssess"></el-input>
        <div class="bottom">
          <Button name="保存" @handleClick="submit"></Button>
        </div>
      </div>
    </div>
    <Popup v-if="popup_bool" :inter-view="interView" get-child-data="true" :getPopupBool="getPopupBool" :getPopupData="getPopupData"></Popup>
  </div>

</template>

<script>
import Popup from '@/components/xueyezixun/InterviewPopup'
import CircleName from "@/components/xueyezixun/CircleName";
import SummaryTitle from "@/components/xueyezixun/SummaryTitle";
import Button from "@/components/xueyezixun/Button";
export default {
  name: "add",
  components:{Popup,CircleName,SummaryTitle,Button},
  data(){
    return {
      studentId: sessionStorage.getItem("myStudentStudentId"),
      studentTestScoreId: this.$route.query.assessmentAddId,
      gradeName: this.$route.query.gradeName,
      nameName: this.$route.query.nameName,
      interView: [{
        category: 4,
        interViewTheme: '阶段评估'
      }],
      popup_bool:true,
      assess: {
        slParentTc: '',
        slStudentTc: '',
        slTeacherTc: '',
        slConsultantTc: '',
        slComplexTc: '',
        slParentCr: '',
        slStudentCr: '',
        slTeacherCr: '',
        slConsultantCr: '',
        slComplexCr: '',

        lhParentTc: '',
        lhStudentTc: '',
        lhTeacherTc: '',
        lhConsultantTc: '',
        lhComplexTc: '',
        lhParentCr: '',
        lhStudentCr: '',
        lhTeacherCr: '',
        lhConsultantCr: '',
        lhComplexCr: '',

        pcParentTc: '',
        pcStudentTc: '',
        pcTeacherTc: '',
        pcConsultantTc: '',
        pcComplexTc: '',
        pcParentCr: '',
        pcStudentCr: '',
        pcTeacherCr: '',
        pcConsultantCr: '',
        pcComplexCr: '',

        overallAssess: ''
      },
      interViewData:''
    }
  },
  methods:{
    getPopupBool(bool) {
       this.popup_bool= bool
    },
    getPopupData(obj){
      this.interViewData=obj
    },
    getData() {
      console.log(this.$route.query.assessmentAddId)
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.implement.getConsultantScore, {
        studentTestScoreId: this.$route.query.assessmentAddId,
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res => {
        if (res.data.code == 2000) {
          let data = res.data.data;
          let assess=this.assess
          assess.slConsultantTc = data.subject&&data.subject.taskComplete
          assess.slConsultantCr = data.subject&&data.subject.completeEffect
          assess.lhConsultantTc = data.learnHabit&&data.learnHabit.taskComplete
          assess.lhConsultantCr = data.learnHabit&&data.learnHabit.completeEffect
          assess.pcConsultantTc = data.pathCondition&&data.pathCondition.taskComplete
          assess.pcConsultantCr = data.pathCondition&&data.pathCondition.completeEffect
          this.assess=assess
        }
      })
    },
    submit(){
      let assess=this.assess
      assess.slComplexTc = Math.round(assess.slParentTc / 100 * 30 + assess.slStudentTc / 100 * 30 + assess.slTeacherTc / 100 * 20 + assess.slConsultantTc / 100 * 20)
      assess.slComplexCr = Math.round(assess.slParentCr / 100 * 30 + assess.slStudentCr / 100 * 30 + assess.slTeacherCr / 100 * 20 + assess.slConsultantCr / 100 * 20)
      assess.lhComplexTc = Math.round(assess.lhParentTc / 100 * 30 + assess.lhStudentTc / 100 * 30 + assess.lhTeacherTc / 100 * 20 + assess.lhConsultantTc / 100 * 20)
      assess.lhComplexCr = Math.round(assess.lhParentCr / 100 * 30 + assess.lhStudentCr / 100 * 30 + assess.lhTeacherCr / 100 * 20 + assess.lhConsultantCr / 100 * 20)
      assess.pcComplexTc = Math.round(assess.pcParentTc / 100 * 30 + assess.pcStudentTc / 100 * 30 + assess.pcTeacherTc / 100 * 20 + assess.pcConsultantTc / 100 * 20)
      assess.pcComplexCr = Math.round(assess.pcParentCr / 100 * 30 + assess.pcStudentCr / 100 * 30 + assess.pcTeacherCr / 100 * 20 + assess.pcConsultantCr / 100 * 20)
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.implement.assessmentAdd, {
        studentId: sessionStorage.getItem("myStudentStudentId"),
        studentTestScoreId:this.studentTestScoreId,
        interviewRecord:this.interViewData,
        assess:assess
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res => {
        if (res.data.code == 2000) {
          this.$router.push({path:'/consultant/minestudent/main/implement/assessment/show',query:{...this.$route.query,assessmentId:res.data.data.id}})
        }
      })
    }
  },
  mounted() {
    this.getData();
    $('input').on('input',()=>{
       let assess=this.assess
      this.assess=JSON.parse(JSON.stringify(assess))
    })
  }
}
</script>
<style scoped lang="less">
@import "./css/index.less";
.bottom{
  text-align: center;
  margin: 30px 0;
}


</style>
<style lang="less">
.implement_assessment_add{
  textarea{
    min-height: 140px !important;
  }
  .add{
    .el-input__inner{
      border: none !important;
    }
    input{
      text-align: center;
    }
  }
}
</style>
